import { createFileRoute } from "@tanstack/react-router";
import KpisDefaultPage from "../../../../pages/kpis/default/page";

export const Route = createFileRoute("/_pathlessLayout/kpis/default")({
    component: KpisDefaultPage,
});
